/**
 * Replaces all digits in a string with zeros.
 * Used for blurring sensitive numerical values.
 */
export const replaceDigitsWithZeros = (value: string): string => {
    return value.replace(/\d/g, "0");
};
/**
 * Replaces all digits in a string with zeros.
 * Used for blurring sensitive numerical values.
 */
export const replaceDigitsWithZeros = (value: string): string => {
    return value.replace(/\d/g, "0");
};
